import React from 'react'
import './landingPage.css'

import PageLinkArrow from '../PageLinkArrow/PageLinkArrow'

const style = {
  bottom: '-70px',
}

const LandingPage = () => {
  return (
    <div>
      <div className="landing-page-container">
        <div className="landing-page-intro">
          <h1 className="m-fancy-text">The Wedding of Gemma & Russell</h1>
          <h2>2nd September 2017</h2>
          <h3>Chateaux De Lisse</h3>
        </div>
        <PageLinkArrow to="venue" customStyle={style} />
      </div>
    </div>
  )
}

export default LandingPage



// WEBPACK FOOTER //
// ./src/components/LandingPage/LandingPage.js